import { createRouterSelector } from '@atlassian/react-resource-router';

const useRouteGroup = createRouterSelector((state) => state.route?.group ?? '');

export const useIsJsmRoute = (): boolean => {
	return useRouteGroup() === 'servicedesk';
};
